/** @jsx jsx */
import Image from "gatsby-image"
import { Box, Text, jsx } from "theme-ui"
import { getFluidGatsbyImage } from "gatsby-source-sanity"
import BlockContent from "@sanity/block-content-to-react"

import SEO from "../components/seo"
import Layout from "../components/layout"

const BlockRenderer = props => {
  return BlockContent.defaultSerializers.types.block(props)
}

const FigureRenderer = ({ node }) => {
  const fluidProps = getFluidGatsbyImage(
    node.asset,
    { maxWidth: 2000 },
    {
      projectId: "r22ajbll",
      dataset: "production",
    }
  )

  return (
    <figure className="image-wrapper">
      <Image fluid={fluidProps} alt={node.alt} />
    </figure>
  )
}

const LegalPage = ({ pageContext }) => (
  <Layout>
    <SEO title={pageContext.header} />
    <Box
      as="section"
      sx={{
        color: "#333",
        padding: "100px 20px 20px",
        h1: {
          fontFamily: "body",
          fontSize: "50px",
          margin: "1em 0",
        },
        a: {
          color: "#333",
          textDecoration: "underline",
        },
        ul: {
          listStyle: "square",
        },
        "h2, h3, h4, h5, h6, p, li": {
          fontFamily: "secondary",
          position: "relative",
          margin: "1em 0px",
          lineHeight: 1.5,
          fontSize: "18px",
        },
      }}
    >
      <Text as="h1" varaint="body">
        {pageContext.header}
      </Text>
      <Box>
        <BlockContent
          blocks={pageContext.content}
          serializers={{
            types: { block: BlockRenderer, figure: FigureRenderer },
          }}
        />
      </Box>
    </Box>
  </Layout>
)

export default LegalPage
